type Props = {
  style: string;
  image: string;
};

const SingleCard = ({ style, image }: Props) => {
  return (
    <div className={`card ${style ? 'card--flipped' : ''}`}>
      <img src={image} alt="card" />
    </div>
  );
};

export default SingleCard;
